import React from 'react';
import Title from '../Title';
import Carousel from '../Homepage/Carousel';
import '../../index.css';
import { useTranslation } from 'react-i18next';


const Clients = () => {
  const { t } = useTranslation();
  return (
    <section className='flex flex-col p-6 md:p-12 gap-6 md:gap-12'>
      <Title>
        {t('clients.clients_title')}
      </Title>
      <Carousel />
    </section>
  );
};

export default Clients;